import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Loader } from "./../../../core/atoms/loader";

import "./ltoPtr.scss";

interface ILtoPtrComponentProps extends React.Props<LtoPtrComponent> {
  lto: IState<ILto>;
}

export class LtoPtrComponent extends React.Component<ILtoPtrComponentProps, {}> {
  public render() {
    if (this.props.lto.status !== "OK") {
      return <Loader/>;
    }

    const abtaAddress = "ABTA Ltd, 30 Park Street, London, SE1 9EQ";
    const abtaPhone = "+44 (0) 20 3117 0599";
    const insurer = "Vantage";
    const ltoAndUs = `${this.props.lto.data.name} and TravelLocal`;
    const ourAddress = "The Engine Shed, Approach Road, Bristol, BS1 6QH";
    const ourPhone = "+44 (0) 117 325 7898";
    const us = "TravelLocal";

    return (
      <div className="width-wrapper lto-terms-conditions">
        <Helmet title={`${this.props.lto.data.name} - Package Travel and Linked Travel Arrangements Regulations`} />
        <header>
          <h2>Key rights under the Package Travel and Linked Travel Arrangements Regulations 2018</h2>
        </header>
        <section>
          <h3>PART 1</h3>
          <h4>General</h4>
          <p>The combination of travel services offered to you is a package within the meaning of the Package Travel and Linked Travel Arrangements Regulations.</p>
          <p>Therefore, you will benefit from all EU rights applying to packages. {ltoAndUs} will be fully responsible for the proper performance of the package as a whole.</p>
          <p>Additionally, as required by law, {ltoAndUs} has/have protection in place to refund your payments and,
             where transport is included in the package, to ensure your repatriation in the event that it becomes/they become insolvent.</p>
          <a href="http://www.legislation.gov.uk/uksi/2018/634/schedule/2/made" target="_blank">
            More information on key rights under the Package Travel and Linked Travel Arrangements Regulations 2018</a>
        </section>
        <section>
          <h3>PART 2</h3>
          <h4>Key rights under the Package Travel and Linked Travel Arrangements Regulations 2018</h4>
          <p>Travellers will receive all essential information about the package before concluding the package travel contract.</p>
          <p>There is always at least one trader who is liable for the proper performance of all the travel services included in the contract.</p>
          <p>Travellers are given an emergency number or details of a contact point where they can get in touch with the organiser or travel agent.</p>
          <p>Travellers may transfer the package to another person, on reasonable notice and possibly subject to additional costs.</p>
          <p>The price of the package may only be increased if specific costs rise (for instance fuel prices), and if expressly provided for in the contract,
             and in any event not later than 20 days before the start of the package. If the price increase exceeds 8% of the price of the package, the traveller
             may terminate the contract. If the organiser reserves the right to a price increase, the traveller has a right to a price reduction if there is a decrease
             in the relevant costs.</p>
          <p>Travellers may terminate the contract without paying any termination fee and get a full refund of any payments if any of the essential elements of the package,
             other than the price, are changed significantly. If before the start of the package the trader responsible for the package cancels the package, travellers are
             entitled to a refund and compensation where appropriate.</p>
          <p>Travellers may terminate the contract without paying any termination fee before the start of the package in the event of exceptional circumstances,
             for instance if there are serious security problems at the destination which are likely to affect the package</p>
          <p>Additionally, travellers may at any time before the start of the package terminate the contract in return for an appropriate and justifiable termination fee.</p>
          <p>If, after the start of the package, significant elements of the package cannot be provided as agreed, suitable alternative arrangements will have to be offered
             to the traveller at no extra cost. Travellers may terminate the contract without paying any termination fee, where services are not performed in accordance with
             the contract and this substantially affects the performance of the package and the organiser fails to remedy the problem.</p>
          <p>Travellers are also entitled to a price reduction or compensation for damages or both where the travel services are not performed or are improperly performed.</p>
          <p>The organiser has to provide assistance if the traveller is in difficulty.</p>
          <p>If the organiser or the retailer becomes insolvent, payments will be refunded. If the organiser or, where applicable, the retailer becomes insolvent after the
             start of the package and if transport is included in the package, repatriation of the travellers is secured. In the event of {us}’s insolvency, {us} has a bond
              with ABTA (membership number P6930). Travellers may contact ABTA at <a target="_blank" href="http://www.abta.com">www.abta.com</a>,
             at {abtaAddress} or on {abtaPhone} if services are denied because of {us}’s insolvency.  In the event of the
             insolvency of any of the Local Tour Operators that feature on the {us} website, {us} has supplier failure insurance in place with {insurer},
             and will either provide an equivalent trip with a different Local Tour Operator, or a refund of any payments made. Travellers may contact {us} at {us}.com,
             at {ourAddress}, or on {ourPhone} if services are denied because of a Local Tour Operators' insolvency.</p>
        </section>
        <section>
          <h3>PART 3</h3>
          <h4>The Package Travel and Linked Travel Arrangements Regulations 2018</h4>
          <a href="http://www.legislation.gov.uk/uksi/2018/634/schedule/2/made" target="_blank">Package Travel and Linked Travel Arrangements Regulations 2018</a>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state: IWebStoreState) => {
  return {
    lto: state.lto,
  };
};

export const LtoPtr = connect(
  mapStateToProps,
)(LtoPtrComponent);
